import Axios from "axios";
var GoodsStockService = (function () {
    function GoodsStockService() {
    }
    GoodsStockService.prototype.getDepotGoodsFormatStock = function (params) {
        return Axios.get("supplierclientapi/suppliergoods/goods_format_stock", { params: params });
    };
    GoodsStockService.createInstance = function () {
        GoodsStockService.getInstance();
    };
    GoodsStockService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return GoodsStockService;
}());
export default GoodsStockService;
